import { useEffect, useState, useCallback } from "react";
import { Plus, Trash2, ChevronUp, ChevronDown, Save } from "lucide-react";
import { toast } from "sonner";
import { api, adminApi } from "../../lib/api";
import { ImageField, Field } from "./ImageField";

export const StaffEditor = () => {
  const [items, setItems] = useState([]);
  const load = useCallback(async () => {
    const { data } = await api.get("/staff");
    setItems(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const patch = (id, key, val) => setItems((p) => p.map((it) => (it.id === id ? { ...it, [key]: val } : it)));

  const add = async () => {
    try {
      await adminApi.post("/staff", { name: "New Member", role: "Role", image: "" });
      toast.success("Member added");
      load();
    } catch { toast.error("Add failed"); }
  };
  const save = async (it) => {
    try {
      await adminApi.put(`/staff/${it.id}`, it);
      toast.success("Saved");
    } catch { toast.error("Save failed"); }
  };
  const remove = async (id) => {
    try { await adminApi.delete(`/staff/${id}`); load(); } catch { toast.error("Delete failed"); }
  };
  const move = async (idx, dir) => {
    const next = [...items];
    const j = idx + dir;
    if (j < 0 || j >= next.length) return;
    [next[idx], next[j]] = [next[j], next[idx]];
    setItems(next);
    try { await adminApi.post("/staff/reorder", next.map((i) => i.id)); } catch { toast.error("Reorder failed"); }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-[#8F877C] text-sm">Add, edit, reorder and remove staff members.</p>
        <button onClick={add} data-testid="staff-add-btn" className="inline-flex items-center gap-2 font-feature text-xs uppercase tracking-widest bg-teal text-obsidian px-4 py-2.5 hover:bg-bone transition-colors"><Plus className="h-4 w-4" /> Add</button>
      </div>
      {items.map((it, idx) => (
        <div key={it.id} data-testid={`staff-edit-${idx}`} className="border border-[#2A201A] bg-surface/40 p-5 space-y-4">
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Name" value={it.name} onChange={(v) => patch(it.id, "name", v)} />
            <Field label="Role" value={it.role} onChange={(v) => patch(it.id, "role", v)} />
          </div>
          <ImageField label="Portrait" value={it.image} onChange={(v) => patch(it.id, "image", v)} />
          <div className="flex items-center gap-2">
            <button onClick={() => save(it)} className="inline-flex items-center gap-2 font-feature text-xs uppercase tracking-widest bg-teal/90 text-obsidian px-4 py-2 hover:bg-teal"><Save className="h-4 w-4" /> Save</button>
            <button onClick={() => move(idx, -1)} className="p-2 border border-[#2A201A] hover:border-teal hover:text-teal transition-colors"><ChevronUp className="h-4 w-4" /></button>
            <button onClick={() => move(idx, 1)} className="p-2 border border-[#2A201A] hover:border-teal hover:text-teal transition-colors"><ChevronDown className="h-4 w-4" /></button>
            <button onClick={() => remove(it.id)} className="ml-auto p-2 border border-[#2A201A] text-[#8F877C] hover:border-destructive hover:text-destructive transition-colors"><Trash2 className="h-4 w-4" /></button>
          </div>
        </div>
      ))}
    </div>
  );
};
